import { Component, OnInit, ViewEncapsulation, OnDestroy, ChangeDetectorRef, HostListener, ViewChild, ElementRef, OnChanges, Input, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  FormArray,
  NgForm,
} from "@angular/forms";
import { AppStateService } from "../../../core-module/services/app-state.service";
import { NgbNavChangeEvent, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {
  distinctUntilChanged,
  pairwise,
  startWith,
  takeUntil,
} from "rxjs";
import { Subscription, Subject } from "rxjs";
import { restore } from "../../../../assets/json/restoreTooltip.en";
import { MidnightShiftCalculationComponent } from "src/app/midnight-shift-calculation/midnight-shift-calculation.component";
import { DynaDimmerStateService } from "../../../core-module/services/state/dyna-dimmer-state.service";
import { FeatureDefaultsStateService } from "../../../core-module/services/state/feature-defaults-state.service";
import { FeatureUtilsService } from "../../../core-module/services/state/feature-utils.service";
import { GraphStateService } from "../../../core-module/services/state/graph-state.service";
@Component({
  standalone: false,
  selector: "app-chartdata-dyna",
  templateUrl: "./chartdata-dyna.component.html",
  styleUrls: ["./chartdata-dyna.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.Emulated,
})
export class ChartdataDynaDimmerComponent
  implements OnInit, OnDestroy, OnChanges, AfterViewInit
{
  @ViewChild("testInput", { static: false }) testInput: ElementRef;
  addForm: FormGroup;
  rows: FormArray;
  rowLength = 0;
  registerForm: FormGroup;
  submitted = false;
  activeIdString: LegacyAny = "1";
  checkValid = true;
  fewFieldValuePresent = false;
  dataToShow = [];
  Max;
  Steps;
  Initial;
  Final;
  timeHHMM;
  outputLevel;
  fadeTime;
  unsubscribe = new Subject<void>();
  unsubscribeGraphType = new Subject<void>();
  unsubscribeNumeric = new Subject<void>();
  isTableValuesChanged = false;
  isValuesNumericGenerated = false;
  tableValueSubmit = false;
  isNumericCreatedRows = false;
  isGraphUpdated = false;
  dynadisableGraph = false;
  defaultColor = true;
  disableAddBtn = false;
  timeHrsMMValuesArr: LegacyAny = [];
  isAscending = false;
  isGraphDragUpdate = false;
  menuState;
  menuPosition;
  menuPositionX;
  menuPositionY;
  menuWidth;
  menuHeight;
  windowWidth;
  windowHeight;
  isclearTableValueFieldscalled: boolean = false;
  selectedRow;
  disableAddAboveBtn = false;
  disableAddBelowBtn = false;
  hideAll: boolean = false;
  disableNumericClear = true;
  dynaenableChecked = false;
  cloLite;
  showDynaDimmer;
  activeHours;
  initialLevel;
  subscription;
  restoreText = restore;
  dynaOverrideMode;
  dynaOverrideMessage;
  dynaEnableMode;
  disable;
  dynaTimeReferenceMode;
  dynaMidNightShiftMode;
  showDynaDimmerEnabledProp;
  showDynaOverrideProp;
  showDynaTimeReferenceProp;
  dynaMidNightShiftDefaultMinimum;
  dynaMidNightShiftDefaultMaximum;
  dynaMidNightShiftDefaultValue;
  dynaDefaultEnabled;
  dynaDefaultTimeBased;
  dynaDefaultOverride;
  dynaEnabledEditedtVal;
  dynaTimeBasedEditedVal;
  dynaOverrideEditedVal;
  isDynaDataError: boolean = false;
  @ViewChild("contextMenu", { static: false }) contextMenu: ElementRef;
  graphRepresentationType = "";
  afterClearField = false;
  fileResponse: LegacyAny = {};
  count: LegacyAny;
  respVal: string;
  maxRowCount: LegacyAny;
  midnightShiftEditedValue: number;
  dynaMidPointShiftValueSub: Subscription;
  graphDynaData: Subscription;
  dynaDefaultValue: Subscription;
  isEdited: LegacyAny;
  pathVal: string;
  getDynaMidPointShiftValueSub: Subscription;
  getDynaMidPointSHiftDefaultPropertiesSub: Subscription;
  getDynaOverrideModeSub: Subscription;
  getDynaShowOverrideEnabledSub: Subscription;
  // Backward-compatible alias used by legacy specs that still reference `component.apiService`.
  apiService: LegacyAny;
  showPdl4:boolean;
  sceneCCTSupport:boolean
  validMidNightPoint: boolean;
  private midnightShiftEmitTimer: LegacyAny;
  private isDestroyed = false;
  constructor(

    private readonly fb: FormBuilder,
    private readonly cdRef: ChangeDetectorRef,
    private readonly modalService: NgbModal,
    private readonly appState: AppStateService,
    private readonly utils: FeatureUtilsService,
    private readonly dynaDimmer: DynaDimmerStateService,
    private readonly graphState: GraphStateService,
    private readonly featureDefaults: FeatureDefaultsStateService
  ) {
    this.addForm = this.fb.group({});
    this.rows = this.fb.array([]);
    this.apiService = {
      getDynaMidPointShiftValue: this.dynaDimmer.getDynaMidPointShiftValue,
      getGraphDynaData: this.graphState.getGraphDynaData,
      getDynaDefaultValue: this.featureDefaults.getDynaDefaultValue,
    };
  }

  ngOnInit() {
    this.sceneCCTSupport =false;
    this.validMidNightPoint = true;
    this.pathVal = this.utils.getImageUrl(window.location.hostname);
    this.isEdited = false;
    const parsedData = this.appState.getDynaDimmerSchema();
    this.maxRowCount = parsedData[0]["properties"]["NumberOfScenes"]["maximum"];
    if (this.maxRowCount > 9){
      this.showPdl4=true;
    }else{
      this.showPdl4=false;
    }
    //  >= 5
    //   ? parsedData[0]["properties"]["NumberOfScenes"]["maximum"]
    //   : 5;
    setTimeout(() => {
      if(parsedData[0]["properties"].hasOwnProperty("Scene1")){
        if(parsedData[0]["properties"]["Scene1"].hasOwnProperty("requiredProperties")){
          if(parsedData[0]["properties"]["Scene1"]["requiredProperties"].includes("Cct")){
          this.sceneCCTSupport=true;
          }
        }
      }
      if (parsedData[0]["properties"].hasOwnProperty("DynadimMode")) {
        this.hideAll = true;
      } else {
        this.hideAll = false;
      }
      this.cdRef.markForCheck();
    }, 0);
    if (parsedData[0]["properties"].hasOwnProperty("DynadimmerEnabled")) {
      if (
        parsedData[0]["properties"]["DynadimmerEnabled"]["default"] === true
      ) {
        this.disable = false;
      } else if (
        parsedData[0]["properties"]["DynadimmerEnabled"]["default"] ===
        undefined
      ) {
        this.disable = false;
      } else {
        this.disable = true;
      }
    } else {
      this.disable = false;
    }
    setTimeout(() => {
      this.dynaMidPointShiftValueSub = this.getDynaMidPointShiftValueSub =
        this.dynaDimmer.getDynaMidPointShiftValue.subscribe((response) => {
          this.midnightShiftEditedValue = Number(response) || 0;
          this.verifyDefaults();
          this.generatePayloadDynaDimmer();
          this.cdRef.markForCheck();
        });

      this.graphDynaData = this.graphState.getGraphDynaData.subscribe(
        (response) => {
          for (let index = 0; index < response.length; index++) {
            const element = response[index];
            this.rows.controls[index]["controls"].timeHHMM.setValue(
              element.dyanXTime
            );
            this.rows.controls[index]["controls"].outputLevel.setValue(
              element.dyanYOutput
            );
            this.rows.controls[index]["controls"].fadeTime.setValue(
              element.dynaZfadeTime
            );
            this.addForm.addControl("rows", this.rows);
            this.rowLength = this.rows.length;
          }
          this.verifyDefaults();
          this.validateOrderOfHHMM();
          this.generatePayloadDynaDimmer();
          this.cdRef.markForCheck();
          this.cdRef.detectChanges();
        }
      );
      this.dynaDefaultValue = this.featureDefaults.getDynaDefaultValue.subscribe(
        (response) => {
          if (response === "valid") {
            this.isclearTableValueFieldscalled = false;
            // Clear the midnight-shift error up front so the row rebuild below
            // validates against the restored state, not the previous error.
            this.validMidNightPoint = true;
            const cntRows = this.rows.length;

            if (cntRows === 10) {
              this.RemoveRow(9);
              this.RemoveRow(8);
              this.RemoveRow(7);
              this.RemoveRow(6);
              this.RemoveRow(5);
              this.RemoveRow(4);
              this.RemoveRow(3);
              this.RemoveRow(2);
              this.RemoveRow(1);
            }

            if (cntRows === 9) {
              this.RemoveRow(8);
              this.RemoveRow(7);
              this.RemoveRow(6);
              this.RemoveRow(5);
              this.RemoveRow(4);
              this.RemoveRow(3);
              this.RemoveRow(2);
              this.RemoveRow(1);
            }

            if (cntRows === 8) {
              this.RemoveRow(7);
              this.RemoveRow(6);
              this.RemoveRow(5);
              this.RemoveRow(4);
              this.RemoveRow(3);
              this.RemoveRow(2);
              this.RemoveRow(1);
            }

            if (cntRows === 7) {
              this.RemoveRow(6);
              this.RemoveRow(5);
              this.RemoveRow(4);
              this.RemoveRow(3);
              this.RemoveRow(2);
              this.RemoveRow(1);
            }

            if (cntRows === 6) {
              this.RemoveRow(5);
              this.RemoveRow(4);
              this.RemoveRow(3);
              this.RemoveRow(2);
              this.RemoveRow(1);
            }

            if (cntRows === 5) {
              this.RemoveRow(4);
              this.RemoveRow(3);
              this.RemoveRow(2);
              this.RemoveRow(1);
            }

            if (cntRows === 4) {
              this.RemoveRow(3);
              this.RemoveRow(2);
              this.RemoveRow(1);
            }

            if (cntRows === 3) {
              this.RemoveRow(2);
              this.RemoveRow(1);
            }

            if (cntRows === 2) {
              this.RemoveRow(1);
            }
            this.addDefaultRowSet();
            //this.featureDefaults.setDynaDefaultColor(true);
            this.dynaDimmer.getDefaultDynaDimmerEnabledMode.subscribe(
              (response) => {
                this.dynaEnableMode = response;
                if (response) {
                  this.disable = false;
                } else {
                  this.disable = true;
                }
                this.dynaDimmer.sendDynaDimmerEnabledMode(response);
              }
            );
            this.dynaDimmer.getDefaultDynaTimeReferencedMode.subscribe(
              (response) => {
                this.dynaTimeReferenceMode = response;
                this.dynaDimmer.sendDynaTimeReferenceMode(response);
              }
            );
            this.dynaDimmer.getDefaultDynaOverrideMode.subscribe((response) => {
              this.dynaOverrideMode = response;
              this.dynaDimmer.sendDynaOveerideMode(response);
            });

            this.midnightShiftEditedValue = 0;
            this.validMidNightPoint = true;
            this.isDynaDataError = false;
            // Publish validity now; the deferred validation timers would otherwise
            // keep Save/Configure disabled for ~500ms after Restore Default.
            this.dynaDimmer.sendisDynaValid(false);
            this.cdRef.markForCheck();
            this.dynaDimmer.sendDynaMidPointShiftValue(0);
          }
        }
      );
      this.dynaDimmer.getDynaDimmerAllScenes.subscribe((resp) => {});
      this.dynaDimmer.getDynaShowEnabled.subscribe((resp) => {
        if (resp === true) this.showDynaDimmerEnabledProp = true;
        else this.showDynaDimmerEnabledProp = false;
      });
      this.dynaDimmer.getDynaShowOverrideEnabled.subscribe((resp) => {
        if (resp === true) this.showDynaOverrideProp = true;
        else this.showDynaOverrideProp = false;
      });
      this.dynaDimmer.getDynaShowTimeReference.subscribe((resp) => {
        if (resp === true) {
          this.showDynaTimeReferenceProp = true;
        } else {
          this.showDynaTimeReferenceProp = false;
        }
      });
      this.dynaDimmer.getDynaDimmerEnabledMode.subscribe((response) => {
        if (response === true) {
          this.dynaEnableMode = true;
          this.disable = false;
        } else if (
          parsedData[0]["properties"].hasOwnProperty("DynadimmerEnabled") &&
          parsedData[0]["properties"]["DynadimmerEnabled"]["default"] ===
            undefined
        ) {
          this.disable = false;
        } else {
          this.dynaEnableMode = false;
          this.disable = true;
          if (parsedData[0]["properties"].hasOwnProperty("DynadimMode")) {
            this.disable = false;
          }
        }
        this.applyDynaRowsDisabledState();
        //FYZUR this.dynaDimmer.sendDynaDimmerEnabledMode(response);
      });

      this.dynaDimmer.getDynaOverrideMode.subscribe((response) => {
        if (response === true) {
          this.dynaOverrideMode = true;
        } else this.dynaOverrideMode = false;
      });
      this.dynaDimmer.getDynaDependencyProp.subscribe((response) => {
        if (response === false) {
          this.dynaOverrideMessage = false;
        } else this.dynaOverrideMessage = true;
      });
      this.dynaDimmer.getDefaultDynaTimeReferencedMode.subscribe((response) => {
        this.dynaTimeReferenceMode = true;
        if (response === true) {
          this.dynaDimmer.sendDynaTimeReferenceMode(true);
        } else {
          this.dynaDimmer.sendDynaTimeReferenceMode(false);
        }
      });
      this.dynaDimmer.getDynaTimeReferencedMode.subscribe((response) => {
        if (response === true) {
          this.dynaTimeReferenceMode = true;
          this.dynaMidNightShiftMode = false;
          //FYZUR this.dynaDimmer.sendDynaTimeReferenceMode(true);
        } else if (response === false) {
          this.dynaTimeReferenceMode = false;
          this.dynaMidNightShiftMode = true;
          //FYZURthis.dynaDimmer.sendDynaTimeReferenceMode(false);
        }
      });
      this.dynaDimmer.getDynaMidPointShiftMode.subscribe((response) => {
        if (this.dynaTimeReferenceMode === false) {
          this.dynaMidNightShiftMode = true;
        } else if (this.dynaTimeReferenceMode === true) {
          this.dynaMidNightShiftMode = false;
        }
      });

      this.dynaDimmer.getDynaMidPointShiftValue.subscribe((response) => {
        this.midnightShiftEditedValue = Number(response) || 0;
      });
      this.getDynaMidPointSHiftDefaultPropertiesSub =
        this.dynaDimmer.getDynaMidPointSHiftDefaultProperties.subscribe(
          (response) => {
            this.dynaMidNightShiftDefaultMinimum = response[0];
            this.dynaMidNightShiftDefaultMaximum = response[1];
            this.dynaMidNightShiftDefaultValue = response[2];
            this.midnightShiftEditedValue = Number(response[2]) || 0;
            this.dynaDimmer.sendDynaMidPointShiftValue(
              this.midnightShiftEditedValue
            );
          }
        );
      this.dynaDimmer.getDefaultDynaDimmerEnabledMode.subscribe((response) => {
        this.dynaDefaultEnabled = response;
      });
      this.dynaDimmer.getDefaultDynaTimeReferencedMode.subscribe((response) => {
        this.dynaDefaultTimeBased = response;
      });
      this.dynaDimmer.getDefaultDynaOverrideMode.subscribe((response) => {
        this.dynaDefaultOverride = response;
      });
      this.dynaDimmer.getDefaultDynaDimmerEnabledMode.subscribe(
        (response) => {}
      );
    }, 0);

    // Use centralized method to get feature data
    // This automatically prioritizes SaveSetData over ConfigurationData
    const dynaData = this.appState.getFeatureData('DynaDimmer');
    if (dynaData) {
      this.fileResponse = { resp: { DynaDimmer: dynaData } };
    }
    this.dataToShow = [];
    this.rows.clear();
    this.onAddRow();
    this.defaultColor = true;
    this.addDefaultRowSet();

    ////
    const unSelectedFeat = this.appState.getUnSelectedFeatConfig();

    let isConfigEdited = false;
    let featIndex: number = 0;
    if (unSelectedFeat != null) {
      unSelectedFeat.forEach((element) => {
        if (
          (element != null) &&
          (element["featureName"] != null) &&
          element["featureName"].toString().toUpperCase() === "DYNADIMMER"
        ) {
          isConfigEdited = true;
          const DYNADIM: LegacyAny = element["featureParameters"][0];
          setTimeout(() => {
          this.addDynaLoadedFeatureReadValues(DYNADIM);
          }, 0);
          unSelectedFeat.splice(featIndex, 1);
          this.appState.setUnSelectedFeatConfig(unSelectedFeat);
        } else {
          featIndex++;
        }
      });
    }

    /////
    if (!isConfigEdited) {
      setTimeout(() => {
      const dynaDimmerLoaddedFetaure = this.appState.getConfigurationData();
      if (dynaDimmerLoaddedFetaure) {
        if (
          dynaDimmerLoaddedFetaure.resp &&
          dynaDimmerLoaddedFetaure.resp.Dynadimmer
        ) {
            //this.isEdited = true;
          this.addDynaLoadedFeatureReadValues(
            dynaDimmerLoaddedFetaure.resp.Dynadimmer
          );
        }
      }
      }, 2000);
    }
    setTimeout(() => {
      this.sendDynaDimmerdata(
        this.appState.getDynaSaveSetData()
      );
      this.isEdited = true;
    }, 1000);


  }

  sendDynaDimmerdata(finalpayload: LegacyAny) {
    if (this.isEdited) {
      this.setConfigurationData(finalpayload, "Dynadimmer");
    }
  }

  setConfigurationData(value, keyVal) {
    if ((value != null)) {
      let touchDimObj = {};
      let data = {};
      const addNew = {
        [keyVal]: {},
      };
      data = this.appState.getConfigurationData();
      if (data && (data["resp"] != null)) {
        touchDimObj = Object.assign({}, value);
        data["resp"][keyVal] = touchDimObj;
      } else {
        data["resp"] = addNew;
        touchDimObj = Object.assign({}, value);
        data["resp"][keyVal] = touchDimObj;
      }
      this.appState.setConfigurationData(data);
    }
  }

  addDynaLoadedFeatureReadValues(dynadimmer: LegacyAny) {
    //dynadimmer: {Scene1: {DimLevel: 90, FadeTime: 25, Minute: 4, Hour: 0}, MidnightShift: 0, TimeReference: false}

    const dynaDimmerObj = dynadimmer;

    const keys = Object.keys(dynaDimmerObj);
    const values = Object.values(dynaDimmerObj);
    const result = [];
    keys.forEach((key, i) => (result[key] = values[i]));
    if (this.dynaOverrideMessage === false) {
      if (
        result["DynadimmerEnabled"] === true ||
        result["DynadimmerEnabled"] === false
      ) {
        this.dynaDimmer.showDynaEnabled(true);
        this.dynaDimmer.sendDynaDimmerEnabledMode(result["DynadimmerEnabled"]);
      } else {
        this.dynaDimmer.showDynaEnabled(false);
      }
    }
    //if (result["TimeReference"] === true) {
    if (result["TimeReference"] === true || result["TimeReference"] === false) {
      this.dynaDimmer.showDynaTimeRefernece(true);
      this.dynaDimmer.sendDynaTimeReferenceMode(result["TimeReference"]);
    } else {
      this.dynaDimmer.showDynaTimeRefernece(false);
    }

    if (this.showDynaOverrideProp) {
      if (result["OverrideMode"] === true || result["OverrideMode"] === false) {
        this.dynaDimmer.showDynaOverrideEnabled(true);
        this.dynaDimmer.sendDynaOveerideMode(result["OverrideMode"]);
      } else {
        this.dynaDimmer.showDynaOverrideEnabled(false);
      }
    }
    // if (result["MidnightShift"].toString().length>0) {

    // }
    // else {
    //   this.dynaDimmer.sendDynaMidPointShiftValue(0);
    // }

    // setTimeout(() => {
    this.dynaDimmer.sendDynaMidPointShiftValue(Number(result["MidnightShift"]));
    // }, 1000);

    this.midnightShiftEditedValue = Number(result["MidnightShift"]);
    this.rows.clear();
    if (result["Scene1"] != undefined) {
      this.addNonDefaultScenes(result["Scene1"], 0);
    }
    if (result["Scene2"] != undefined) {
      this.addNonDefaultScenes(result["Scene2"], 1);
    }
    if (result["Scene3"] != undefined) {
      this.addNonDefaultScenes(result["Scene3"], 2);
    }
    if (result["Scene4"] != undefined) {
      this.addNonDefaultScenes(result["Scene4"], 3);
    }
    if (result["Scene5"] != undefined) {
      this.addNonDefaultScenes(result["Scene5"], 4);
    }
    if (result["Scene6"] != undefined) {
      this.addNonDefaultScenes(result["Scene6"], 5);
    }
    if (result["Scene7"] != undefined) {
      this.addNonDefaultScenes(result["Scene7"], 6);
    }
    if (result["Scene8"] != undefined) {
      this.addNonDefaultScenes(result["Scene8"], 7);
    }
    if (result["Scene9"] != undefined) {
      this.addNonDefaultScenes(result["Scene9"], 8);
    }
    if (result["Scene10"] != undefined) {
      this.addNonDefaultScenes(result["Scene10"], 9);
    }
    this.verifyDefaults();
    this.applyDynaRowsDisabledState(); 
  }
  addNonDefaultScenes(scene: LegacyAny, sceneNum: number) {
    this.onAddRow();
    this.rows.controls[sceneNum]["controls"].timeHHMM.setValue(
      String(
        this.getCorrectValue(scene.Hour) +
          ":" +
          this.getCorrectValue(scene.Minute)
      )
    );
    this.rows.controls[sceneNum]["controls"].outputLevel.setValue(
      Number(scene.DimLevel)
    );
    this.rows.controls[sceneNum]["controls"].fadeTime.setValue(
      Number(scene.FadeTime)
    );
    this.addForm.addControl("rows", this.rows);
    this.rowLength = this.rows.length;
    this.appState.setDynaScenes({
      timeHHMM: String(scene.Hour + ":" + scene.Minute),
      outputLevel: Number(scene.DimLevel),
      fadeTime: Number(scene.FadeTime),
    });
    this.validateOrderOfHHMM();
    this.generatePayloadDynaDimmer();
    this.cdRef.markForCheck();
    this.cdRef.detectChanges();
  }
  getCorrectValue(data: LegacyAny) {
    if (data.toString().length === 1) {
      return "0" + data;
    }
    return data;
  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }

  ngOnChanges() {
    this.verifyDefaults();
  }
  defaultRows() {
    const lengthOfRow = this.rows.length;

    for (let index = 0; index < lengthOfRow; index++) {
      this.rows.removeAt(index);
    }
  }
  addDefaultRowSet() {
    const dynaDimmerReadSchema = this.appState.getDynaDimmerSchema();
    const scenes =
      dynaDimmerReadSchema[0]["properties"]["NumberOfScenes"]["default"];
    this.defaultColor = false;
    this.featureDefaults.setDynaDefaultColor(this.defaultColor);
    if (scenes > 1) {
      for (let i = 0; i <= scenes - 1; i++) {
        const k = i + 1;
        if (this.isclearTableValueFieldscalled === true) {
          const fadeTimeDefault: LegacyAny = 0;
          const outputLevelDefault: LegacyAny = 100;
          this.rows.controls[0]["controls"].timeHHMM.setValue("12:00");
          this.rows.controls[0]["controls"].outputLevel.setValue(
            outputLevelDefault
          );
          this.rows.controls[0]["controls"].fadeTime.setValue(fadeTimeDefault);
          this.addForm.addControl("rows", this.rows);
          this.rowLength = this.rows.length;
          this.appState.setDynaScenes({
            timeHHMM: "12:00",
            outputLevel: outputLevelDefault,
            fadeTime: fadeTimeDefault,
          });
        } else if (this.isclearTableValueFieldscalled === false) {
          let hourDefault =
            dynaDimmerReadSchema[0]["properties"]["Scene" + `${k}`][
              "properties"
            ]["Hour"]["default"];
          let minuteDefault =
            dynaDimmerReadSchema[0]["properties"]["Scene" + `${k}`][
              "properties"
            ]["Minute"]["default"];
          const fadeTimeDefault =
            dynaDimmerReadSchema[0]["properties"]["Scene" + `${k}`][
              "properties"
            ]["FadeTime"]["default"];
          const outputLevelDefault =
            dynaDimmerReadSchema[0]["properties"]["Scene" + `${k}`][
              "properties"
            ]["DimLevel"]["default"];
          hourDefault = hourDefault <= 9 ? "0" + hourDefault : hourDefault;
          minuteDefault =
            minuteDefault <= 9 ? "0" + minuteDefault : minuteDefault;
          if (i > 0 && i <= scenes - 1) {
            this.onAddRow();
          }
          const time = `${hourDefault}` + ":" + `${minuteDefault}`;
          this.rows.controls[i]["controls"].timeHHMM.setValue(time);
          this.rows.controls[i]["controls"].outputLevel.setValue(
            outputLevelDefault
          );
          this.rows.controls[i]["controls"].fadeTime.setValue(fadeTimeDefault);
          this.addForm.addControl("rows", this.rows);
          this.rowLength = this.rows.length;
          const dataToPush = {};
          dataToPush[i] = {
            timeHHMM: time,
            outputLevel: outputLevelDefault,
            fadeTime: fadeTimeDefault,
          };
          this.appState.setDynaScenes(dataToPush);
        }
      }
    } else {
      if (this.isclearTableValueFieldscalled === true) {
        const fadeTimeDefault: LegacyAny = 0;
        const outputLevelDefault: LegacyAny = 100;
        this.rows.controls[0]["controls"].timeHHMM.setValue("15:00");
        this.rows.controls[0]["controls"].outputLevel.setValue(
          outputLevelDefault
        );
        this.rows.controls[0]["controls"].fadeTime.setValue(fadeTimeDefault);
        this.addForm.addControl("rows", this.rows);
        this.rowLength = this.rows.length;
        this.appState.setDynaScenes({
          timeHHMM: "15:00",
          outputLevel: outputLevelDefault,
          fadeTime: fadeTimeDefault,
        });
      } else if (this.isclearTableValueFieldscalled === false) {
        let hourDefault =
          dynaDimmerReadSchema[0]["properties"]["Scene1"]["properties"]["Hour"][
            "default"
          ];
        let minuteDefault =
          dynaDimmerReadSchema[0]["properties"]["Scene1"]["properties"][
            "Minute"
          ]["default"];
        const fadeTimeDefault =
          dynaDimmerReadSchema[0]["properties"]["Scene1"]["properties"][
            "FadeTime"
          ]["default"];
        const outputLevelDefault =
          dynaDimmerReadSchema[0]["properties"]["Scene1"]["properties"][
            "DimLevel"
          ]["default"];
        hourDefault = hourDefault <= 9 ? "0" + hourDefault : hourDefault;
        minuteDefault =
          minuteDefault <= 9 ? "0" + minuteDefault : minuteDefault;
        const time = `${hourDefault}` + ":" + `${minuteDefault}`;
        this.rows.controls[0]["controls"].timeHHMM.setValue(time);
        this.rows.controls[0]["controls"].outputLevel.setValue(
          outputLevelDefault
        );
        this.rows.controls[0]["controls"].fadeTime.setValue(fadeTimeDefault);
        this.addForm.addControl("rows", this.rows);
        this.rowLength = this.rows.length;
        this.appState.setDynaScenes({
          timeHHMM: time,
          outputLevel: outputLevelDefault,
          fadeTime: fadeTimeDefault,
        });
      }
    }

    this.validateOrderOfHHMM();
    this.generatePayloadDynaDimmer();
    this.applyDynaRowsDisabledState();
  }

  inputValueChanged($event) {
    this.fewFieldValuePresent = false;
    if ($event.key !== "Tab") {
      this.submitted = true;
    }
    if ($event.key === "Backspace" || $event.key === "Delete") {
      this.submitted = false;

      if (this.fewFieldValuePresent === false) {
        this.graphState.sendGraphValidData("valid");
      }
    }
  }

  onKey($event) {
    setTimeout(() => {
      this.validateOrderOfHHMM();
      const dynaDimmerReadSchema = this.appState.getDynaDimmerSchema();
      const formArray = (<FormArray>this.addForm.get("rows")).controls;
      for (let i = 0; i < formArray.length; i++) {
        const controlOutputLevelMinimum =
          dynaDimmerReadSchema[0]["properties"]["Scene" + `${i + 1}`][
            "properties"
          ]["DimLevel"]["minimum"];
        const control = (<LegacyAny>formArray[i]).controls;
        const controlsArray = ["timeHHMM", "outputLevel", "fadeTime"];
        for (let j = 0; j < controlsArray.length; j++) {
          if (`${controlsArray[j]}` === "outputLevel") {
            control[`${controlsArray[j]}`].valueChanges
              .pipe(distinctUntilChanged())
              .subscribe((data) => {
                // Handle empty values
                if (data === null || data === undefined || data === '') {
                  this.isDynaDataError = true;
                  this.dynaDimmer.sendisDynaValid(this.isDynaDataError);
                  return;
                }
                if (data) {
                  setTimeout(() => {
                    const numValue = parseInt(data);

                    // Set error if value exceeds maximum (100) for output level
                    if (numValue > 100) {
                      control[`${controlsArray[j]}`].markAsDirty();
                      control[`${controlsArray[j]}`].markAsTouched();
                      control[`${controlsArray[j]}`].setErrors({
                        max: true,
                      });
                    } else if (numValue < controlOutputLevelMinimum) {
                      control[`${controlsArray[j]}`].markAsDirty();
                      control[`${controlsArray[j]}`].markAsTouched();
                      control[`${controlsArray[j]}`].setErrors({
                        invalid: true,
                      });
                    }
                    this.isDynaDataError = this.hasDynaError();
                    this.dynaDimmer.sendisDynaValid(this.isDynaDataError);
                    //control[`${controlsArray[j]}`].updateValueAndValidity();
                  }, 100);
                }
              });
          } else if (`${controlsArray[j]}` !== "outputLevel") {
            control[`${controlsArray[j]}`].valueChanges
              .pipe(distinctUntilChanged())
              .subscribe((data) => {
                // Handle empty values - mark as error immediately
                if (data === null || data === undefined || data === '') {
                  this.isDynaDataError = true;
                  this.dynaDimmer.sendisDynaValid(this.isDynaDataError);
                  return;
                }
                if (data) {
                  if (control[`${controlsArray[j]}`].errors !== null) {
                    this.isDynaDataError = true;
                  } else {
                    this.isDynaDataError = this.hasDynaError();
                  }
                  this.dynaDimmer.sendisDynaValid(this.isDynaDataError);
                  control[`${controlsArray[j]}`].updateValueAndValidity();
                }
              });
          }
        }
      }
      this.verifyDefaults();
    }, 200);
  }

  // Validate input values and set errors if exceeding maximum
  private validateInputValue(event: LegacyAny, index: number, fieldName: string, maxValue: number): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Remove non-numeric characters
    value = value.replace(/[^0-9]/g, '');

    // Set validation error if value exceeds maximum
    const control = this.rows.controls[index].get(fieldName);
    if (!value) {
      // Field was cleared — signal invalid state immediately
      this.isDynaDataError = true;
      this.dynaDimmer.sendisDynaValid(this.isDynaDataError);
      this.cdRef.markForCheck();
      this.onKey(event);
      return;
    }
    if (parseInt(value) > maxValue) {
      control?.markAsDirty();
      control?.markAsTouched();
      control?.setErrors({ max: true });
      this.isDynaDataError = true;
      this.dynaDimmer.sendisDynaValid(this.isDynaDataError);
      this.cdRef.markForCheck();
    } else if (parseInt(value) >= 0) {
      // Clear max error if value is now valid
      if (control?.errors && control.errors['max']) {
        control.setErrors(null);
      }
      this.isDynaDataError = this.hasDynaError();
      this.dynaDimmer.sendisDynaValid(this.isDynaDataError);
      this.cdRef.markForCheck();
    }

    // Call the original onKey handler
    this.onKey(event);
  }

  // Output level input handler using generic method
  onOutputLevelInput(event: LegacyAny, index: number) {
    this.validateInputValue(event, index, 'outputLevel', 100);
    this.verifyDefaults();
    this.dynaDimmer.emitDynaUserInteracted();
  }

  // Fade time input handler using generic method
  onFadeTimeInput(event: LegacyAny, index: number) {
    this.validateInputValue(event, index, 'fadeTime', 255);
    this.verifyDefaults();
    this.dynaDimmer.emitDynaUserInteracted();
  }

  // Time input handler for triggering include in configuration
  onTimeInput() {
    const hasError = this.hasDynaError();
    this.isDynaDataError = hasError;
    this.dynaDimmer.sendisDynaValid(hasError);
    this.cdRef.markForCheck();
    this.verifyDefaults();
    this.dynaDimmer.emitDynaUserInteracted();
  }

  // Generic method to restrict keypress to allowed characters
  private restrictKeyPress(event: KeyboardEvent, allowedKeys: string[] = []): boolean {
    const key = event.key;

    // Allow: backspace, delete, tab, escape, enter
    if (['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'].includes(key)) {
      return true;
    }

    // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
    if (['a', 'c', 'v', 'x'].includes(key.toLowerCase()) && event.ctrlKey) {
      return true;
    }

    // Allow numbers (0-9)
    if (key >= '0' && key <= '9') {
      return true;
    }

    // Allow additional characters if specified
    if (allowedKeys.length > 0 && allowedKeys.includes(key)) {
      return true;
    }

    // Prevent all other characters
    event.preventDefault();
    return false;
  }

  // Allow only numeric input (0-9)
  onNumericKeyPress(event: KeyboardEvent): boolean {
    return this.restrictKeyPress(event);
  }

  // Allow only numeric input and colon for time field (0-9 and :)
  onTimeKeyPress(event: KeyboardEvent): boolean {
    return this.restrictKeyPress(event, [':']);
  }

  // Allow only numeric input and minus sign for midnight shift field (0-9 and -)
  onMidnightShiftKeyPress(event: KeyboardEvent): boolean {
    const key = event.key;
    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value || '';

    // Special handling for minus sign - only at beginning
    if (key === '-') {
      if (currentValue.length === 0 || inputElement.selectionStart === 0) {
        return true;
      }
      event.preventDefault();
      return false;
    }

    // Use generic method for other characters
    return this.restrictKeyPress(event);
  }

  // Generic method to handle paste events
  private handlePaste(event: ClipboardEvent, allowedPattern: RegExp, maxLength?: number): void {
    event.preventDefault();

    const pastedText = event.clipboardData?.getData('text') || '';
    const cleanedText = pastedText.replace(allowedPattern, '');

    if (cleanedText) {
      const inputElement = event.target as HTMLInputElement;
      const currentValue = inputElement.value || '';
      const start = inputElement.selectionStart || 0;
      const end = inputElement.selectionEnd || 0;

      // Insert cleaned text at cursor position
      let newValue = currentValue.substring(0, start) + cleanedText + currentValue.substring(end);

      // Enforce max length if specified
      if (maxLength && newValue.length > maxLength) {
        newValue = newValue.substring(0, maxLength);
      }

      inputElement.value = newValue;

      // Trigger input event to update form control
      inputElement.dispatchEvent(new Event('input', { bubbles: true }));

      // Set cursor position
      const newCursorPos = Math.min(start + cleanedText.length, newValue.length);
      inputElement.setSelectionRange(newCursorPos, newCursorPos);
    }
  }

  // Handle paste for numeric-only fields
  onNumericPaste(event: ClipboardEvent): void {
    this.handlePaste(event, /[^0-9]/g);
  }

  // Handle paste for time fields (numeric + colon)
  onTimePaste(event: ClipboardEvent): void {
    this.handlePaste(event, /[^0-9:]/g, 5);
  }

  // Handle paste for midnight shift field (numeric + minus at start)
  onMidnightShiftPaste(event: ClipboardEvent): void {
    event.preventDefault();

    const pastedText = event.clipboardData?.getData('text') || '';
    // Allow only numbers and optionally a leading minus sign
    const cleanedText = pastedText.replace(/[^0-9-]/g, '');

    // Ensure minus sign is only at the beginning
    let finalText = cleanedText.replace(/-/g, '');
    if (cleanedText.startsWith('-')) {
      finalText = '-' + finalText;
    }

    if (finalText) {
      const inputElement = event.target as HTMLInputElement;
      inputElement.value = finalText;
      inputElement.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  onMouseLeave() {
    this.validateOrderOfHHMM();
    //this.verifyDefaults();
  }

  onAddRow() {
    this.rows.push(this.createItemFormGroup());
    this.checkAddesRowValuesChanged(this.rows.length - 1);
    this.rowLength = this.rows.length;

    setTimeout(() => {}, 100);
    this.validateOrderOfHHMM();

    // Use centralized method for button state updates
    this.updateAddButtonStates();
  }
  validateOrderOfHHMM() {
    // Don't reset error if midnight shift field is invalid (empty)
    if (this.validMidNightPoint !== false) {
      this.isDynaDataError = false;
    }

    let isValidTime: boolean = true;
    const scenesCnt = this.rows.value.length;
    let timeHHForSorting: LegacyAny[] = [];

    // Check if all rows have complete data before processing
    let hasIncompleteData = false;

    for (let i = 0; i < scenesCnt; i++) {
      const timeValue = this.rows.value[i].timeHHMM;
      const outputValue = this.rows.value[i].outputLevel;
      // Skip rows with empty or null values - don't process incomplete data
      if (!timeValue || timeValue === '' ||
          outputValue === null || outputValue === undefined || outputValue === '') {
        hasIncompleteData = true;
        continue;
      }

      const tthhmm: string = timeValue.toString().split(":", "2")[0];
      const tthhmm1: string = timeValue.toString();
      const dimlevel1: string = outputValue.toString();

      if (
        parseFloat(tthhmm) < 12 &&
        parseFloat(tthhmm) > 11 &&
        this.dynaTimeReferenceMode === false
      ) {
        this.rows.controls[i]["controls"].timeHHMM.setValue("");
        isValidTime = false;
      } else {
        timeHHForSorting.push(tthhmm1 + "_" + dimlevel1);
      }
    }

    // If there's incomplete data, mark as error but preserve existing graph data
    if (hasIncompleteData) {
      this.isDynaDataError = true;
      setTimeout(() => this.publishDynaValidity(), 600);
      return;
    }

    // If LegacyAny row has out-of-range values, mark as error but preserve existing graph data
    let hasOutOfRangeData = false;
    for (let i = 0; i < scenesCnt; i++) {
      const outputValue = parseInt(this.rows.value[i].outputLevel);
      const fadeTimeValue = parseInt(this.rows.value[i].fadeTime);
      if (outputValue > 100 || fadeTimeValue > 255) {
        hasOutOfRangeData = true;
        break;
      }
    }
    if (hasOutOfRangeData) {
      this.isDynaDataError = true;
      setTimeout(() => this.publishDynaValidity(), 600);
      return;
    }

    // Only clear scenes now that we have complete data to rebuild from
    this.appState.removeDynaScenes();
    if (isValidTime) {
      if (timeHHForSorting != null) {
        if (this.dynaTimeReferenceMode === true) {
        timeHHForSorting.sort((a, b) => {
          let atime1 = a.toString().split("_")[0].split(":")[0];
          const atime2 = a.toString().split("_")[0].split(":")[1];
          let btime1 = b.toString().split("_")[0].split(":")[0];
          const btime2 = b.toString().split("_")[0].split(":")[1];

          if (atime1.length === 1) atime1 = "0" + atime1;
          if (btime1.length === 1) btime1 = "0" + btime1;

          const finaltimeA = new Date(
            "1900-01-01T" + atime1 + ":" + atime2
          ).getTime();
          const finaltimeB = new Date(
            "1900-01-01T" + btime1 + ":" + btime2
          ).getTime();

          if (finaltimeA === finaltimeB) return 0;

          return finaltimeA < finaltimeB ? -1 : 1;
        });
        }
        // else
        //   timeHHForSorting.sort()
      }
      if (this.dynaTimeReferenceMode !== true) {
        const nonTimeBased15to24: LegacyAny[] = [];
        const nonTimeBased1to10: LegacyAny[] = [];

        timeHHForSorting.forEach((elementArr) => {
          if (
            parseFloat(elementArr.split("_")[0].split(":")[0]) >= 12 &&
            parseFloat(elementArr.split("_")[0].split(":")[0]) <= 24
          ) {
            nonTimeBased15to24.push(elementArr);
          }
          if (
            parseFloat(elementArr.split("_")[0].split(":")[0]) >= 0 &&
            parseFloat(elementArr.split("_")[0].split(":")[0]) <= 11
          ) {
            nonTimeBased1to10.push(elementArr);
          }
        });

        nonTimeBased15to24.sort((a, b) => {
          // if (a === b)
          //   return 0;

          // return a < b ? -1 : 1
          // let finaltimeA = new Date("1900-01-01T"+a).getTime();
          // let finaltimeB = new Date("1900-01-01T"+b).getTime();

          let atime1 = a.toString().split("_")[0].split(":")[0];
          const atime2 = a.toString().split("_")[0].split(":")[1];
          let btime1 = b.toString().split("_")[0].split(":")[0];
          const btime2 = b.toString().split("_")[0].split(":")[1];

          if (atime1.length === 1) atime1 = "0" + atime1;
          if (btime1.length === 1) btime1 = "0" + btime1;

          const finaltimeA = new Date(
            "1900-01-01T" + atime1 + ":" + atime2
          ).getTime();
          const finaltimeB = new Date(
            "1900-01-01T" + btime1 + ":" + btime2
          ).getTime();

          if (finaltimeA === finaltimeB) return 0;

          return finaltimeA < finaltimeB ? -1 : 1;
        });
        nonTimeBased1to10.sort((a, b) => {
          // if (a === b)
          //   return 0;

          // return a < b ? -1 : 1
          // let finaltimeA = new Date("1900-01-01T"+a).getTime();
          // let finaltimeB = new Date("1900-01-01T"+b).getTime();

          let atime1 = a.toString().split("_")[0].split(":")[0];
          const atime2 = a.toString().split("_")[0].split(":")[1];
          let btime1 = b.toString().split("_")[0].split(":")[0];
          const btime2 = b.toString().split("_")[0].split(":")[1];

          if (atime1.length === 1) atime1 = "0" + atime1;
          if (btime1.length === 1) btime1 = "0" + btime1;

          const finaltimeA = new Date(
            "1900-01-01T" + atime1 + ":" + atime2
          ).getTime();
          const finaltimeB = new Date(
            "1900-01-01T" + btime1 + ":" + btime2
          ).getTime();

          if (finaltimeA === finaltimeB) return 0;

          return finaltimeA < finaltimeB ? -1 : 1;
        });
        timeHHForSorting = [];

        nonTimeBased15to24.forEach((element) => {
          timeHHForSorting.push(element);
        });

        nonTimeBased1to10.forEach((element) => {
          timeHHForSorting.push(element);
        });
      }
      const finalArrayToSory: LegacyAny[] = [];
      timeHHForSorting.forEach((element) => {
        for (let i = 0; i < scenesCnt; i++) {
          let tthhmmCheck: string = "";
          let dimOtLlv: string = "";
          const timeValue = this.rows.value[i].timeHHMM;
          const outputValue = this.rows.value[i].outputLevel;

          // Skip rows with empty or null values
          if (timeValue && timeValue !== '' &&
              outputValue !== null && outputValue !== undefined && outputValue !== '') {
            tthhmmCheck = timeValue.toString();
            dimOtLlv = outputValue.toString();
          } else {
            continue;
          }

          if (
            element.split("_")[0] === tthhmmCheck &&
            element.split("_")[1] === dimOtLlv
          ) {
            finalArrayToSory.push(this.rows.value[i]);
            break;
          }
        }
      });

      for (let i = 0; i < finalArrayToSory.length; i++) {
        const element = finalArrayToSory[i];
        this.rows.controls[i]["controls"].timeHHMM.setValue(element.timeHHMM);
        this.rows.controls[i]["controls"].outputLevel.setValue(
          element.outputLevel
        );
        this.rows.controls[i]["controls"].fadeTime.setValue(element.fadeTime);
      }
      this.appState.setDynaScenes(finalArrayToSory);
      this.defaultColor = false;
      this.generatePayloadDynaDimmer();
      //localStorage.setItem('dynaSaveSetData', JSON.stringify())
      this.dynaDimmer.setFinalDynaDimmerData(JSON.stringify(finalArrayToSory));
    }
    setTimeout(() => {
      this.publishDynaValidity();
    }, 500);
  }

  textValChanged(value) {
    // If time based is enabled, field is disabled - skip validation
    if (this.dynaTimeReferenceMode) {
      return;
    }

    // A queued emit reads midnightShiftEditedValue when it fires, and ngModel
    // has already set that to null - the subscriber would turn it back into 0.
    clearTimeout(this.midnightShiftEmitTimer);

    // Check if empty - set error like table inputs do
    if (value === "" || value === null || value === undefined) {
      this.isDynaDataError = true;
      this.validMidNightPoint = false;
      this.dynaDimmer.sendisDynaValid(this.isDynaDataError);
      this.verifyDefaults();
      this.dynaDimmer.emitDynaUserInteracted();
      return;
    }

    const newValue = Number(value);
    const isValidMidnightShift =
      !isNaN(newValue) && newValue >= -120 && newValue <= 120;

    this.validMidNightPoint = isValidMidnightShift;
    this.isDynaDataError = !isValidMidnightShift;
    this.dynaDimmer.sendisDynaValid(this.isDynaDataError);

    if (!isValidMidnightShift) {
      if (!isNaN(newValue)) {
        this.midnightShiftEditedValue = Number(newValue);
      }
      this.validateOrderOfHHMM();
      this.verifyDefaults();
      this.dynaDimmer.emitDynaUserInteracted();
      return;
    }

    this.midnightShiftEditedValue = Number(newValue);

    this.midnightShiftEmitTimer = setTimeout(() => {
      this.dynaDimmer.sendDynaMidPointShiftValue(
        this.midnightShiftEditedValue
      );
    }, 1000);

    this.validateOrderOfHHMM();
    this.verifyDefaults();
    this.dynaDimmer.emitDynaUserInteracted();

    // setTimeout(() => {
    //
    // }, 1000);
  }
  generatePayloadDynaDimmer() {
    let DynadimmerEnabled: LegacyAny[] = [];
    let MidnightShift: LegacyAny[] = [];
    let TimeReference: LegacyAny[] = [];
    let OverrideMode: LegacyAny[] = [];
    let featureParametersObj: LegacyAny = null;
    let Scene1 = null;
    let Scene2 = null;
    let Scene3 = null;
    let Scene4 = null;
    let Scene5 = null;
    let Scene6 = null;
    let Scene7 = null;
    let Scene8 = null;
    let Scene9 = null;
    let Scene10 = null;
    this.dynaDimmer.getDynaShowEnabled.subscribe((response) => {
      DynadimmerEnabled = [];
      DynadimmerEnabled.push("DynadimmerEnabled");
      if (response === true) {
        this.dynaDimmer.getDynaDimmerEnabledMode.subscribe((rsp) => {
          const enableddyna = Boolean(rsp);

          DynadimmerEnabled.push(enableddyna);
        });
      } else {
        DynadimmerEnabled.push(false);
      }
    });
    this.dynaDimmer.getDynaMidPointShiftValue.subscribe((response) => {
      MidnightShift = [];
      MidnightShift.push("MidnightShift");
      MidnightShift.push(response);
    });
    this.dynaDimmer.getDynaShowTimeReference.subscribe((response) => {
      TimeReference = [];
      TimeReference.push("TimeReference");
      if (response === true) {
        this.dynaDimmer.getDynaTimeReferencedMode.subscribe((rsp) => {
          const timerefenb = Boolean(rsp);
          TimeReference.push(timerefenb);
        });
      } else {
        TimeReference.push(false);
      }
    });
    this.getDynaShowOverrideEnabledSub =
      this.dynaDimmer.getDynaShowOverrideEnabled.subscribe((response) => {
        OverrideMode = [];
        OverrideMode.push("OverrideMode");
        if (response === true) {
          this.getDynaOverrideModeSub =
            this.dynaDimmer.getDynaOverrideMode.subscribe((rsp) => {
              const overrideEnb = Boolean(rsp);
              OverrideMode.push(overrideEnb);
            });
        } else {
          OverrideMode.push(false);
        }
      });

    const scenesData = this.appState.getDynaScenes() || [];

    for (let i = 0; i < scenesData.length; i++) {
      const element = scenesData[i];
      const hour = element.timeHHMM.split(":", 2)[0];
      const minute = element.timeHHMM.split(":", 2)[1];
      const dimLevel = element.outputLevel;
      const fadeTime = element.fadeTime;
      if(this.sceneCCTSupport){
        if (i === 0) {
          Scene1 = {
            Hour: Number(hour),
            Minute: Number(minute),
            DimLevel: Number(dimLevel),
            FadeTime: Number(fadeTime),
            Cct:65535
          };
        }
        if (i === 1) {
          Scene2 = {
            Hour: Number(hour),
            Minute: Number(minute),
            DimLevel: Number(dimLevel),
            FadeTime: Number(fadeTime),
            Cct:65535
          };
        }
        if (i === 2) {
          Scene3 = {
            Hour: Number(hour),
            Minute: Number(minute),
            DimLevel: Number(dimLevel),
            FadeTime: Number(fadeTime),
            Cct:65535
          };
        }
        if (i === 3) {
          Scene4 = {
            Hour: Number(hour),
            Minute: Number(minute),
            DimLevel: Number(dimLevel),
            FadeTime: Number(fadeTime),
            Cct:65535
          };
        }
        if (i === 4) {
          Scene5 = {
            Hour: Number(hour),
            Minute: Number(minute),
            DimLevel: Number(dimLevel),
            FadeTime: Number(fadeTime),
            Cct:65535
          };
        }
        if (i === 5) {
          Scene6 = {
            Hour: Number(hour),
            Minute: Number(minute),
            DimLevel: Number(dimLevel),
            FadeTime: Number(fadeTime),
            Cct:65535
          };
        }
        if (i === 6) {
          Scene7 = {
            Hour: Number(hour),
            Minute: Number(minute),
            DimLevel: Number(dimLevel),
            FadeTime: Number(fadeTime),
            Cct:65535
          };
        }
        if (i === 7) {
          Scene8 = {
            Hour: Number(hour),
            Minute: Number(minute),
            DimLevel: Number(dimLevel),
            FadeTime: Number(fadeTime),
            Cct:65535
          };
        }
        if (i === 8) {
          Scene9 = {
            Hour: Number(hour),
            Minute: Number(minute),
            DimLevel: Number(dimLevel),
            FadeTime: Number(fadeTime),
            Cct:65535
          };
        }
        if (i === 9) {
          Scene10 = {
            Hour: Number(hour),
            Minute: Number(minute),
            DimLevel: Number(dimLevel),
            FadeTime: Number(fadeTime),
            Cct:65535
          };
        }
      }
      else{
      if (i === 0) {
        Scene1 = {
          Hour: Number(hour),
          Minute: Number(minute),
          DimLevel: Number(dimLevel),
          FadeTime: Number(fadeTime),
        };
      }
      if (i === 1) {
        Scene2 = {
          Hour: Number(hour),
          Minute: Number(minute),
          DimLevel: Number(dimLevel),
          FadeTime: Number(fadeTime),
        };
      }
      if (i === 2) {
        Scene3 = {
          Hour: Number(hour),
          Minute: Number(minute),
          DimLevel: Number(dimLevel),
          FadeTime: Number(fadeTime),
        };
      }
      if (i === 3) {
        Scene4 = {
          Hour: Number(hour),
          Minute: Number(minute),
          DimLevel: Number(dimLevel),
          FadeTime: Number(fadeTime),
        };
      }
      if (i === 4) {
        Scene5 = {
          Hour: Number(hour),
          Minute: Number(minute),
          DimLevel: Number(dimLevel),
          FadeTime: Number(fadeTime),
        };
      }
      if (i === 5) {
        Scene6 = {
          Hour: Number(hour),
          Minute: Number(minute),
          DimLevel: Number(dimLevel),
          FadeTime: Number(fadeTime),
        };
      }
      if (i === 6) {
        Scene7 = {
          Hour: Number(hour),
          Minute: Number(minute),
          DimLevel: Number(dimLevel),
          FadeTime: Number(fadeTime),
        };
      }
      if (i === 7) {
        Scene8 = {
          Hour: Number(hour),
          Minute: Number(minute),
          DimLevel: Number(dimLevel),
          FadeTime: Number(fadeTime),
        };
      }
      if (i === 8) {
        Scene9 = {
          Hour: Number(hour),
          Minute: Number(minute),
          DimLevel: Number(dimLevel),
          FadeTime: Number(fadeTime),
        };
      }
      if (i === 9) {
        Scene10 = {
          Hour: Number(hour),
          Minute: Number(minute),
          DimLevel: Number(dimLevel),
          FadeTime: Number(fadeTime),
        };
      }}
    }

    const FinaPayloadDyna: LegacyAny[] = [];

    featureParametersObj = {
      DynadimmerEnabled: DynadimmerEnabled[1],
      MidnightShift: Number(MidnightShift[1]),
      TimeReference: TimeReference[1],
      OverrideMode: OverrideMode[1],
      Scene1,
      Scene2,
      Scene3,
      Scene4,
      Scene5,
      Scene6,
      Scene7,
      Scene8,
      Scene9,
      Scene10,
    };
    if (
      this.showDynaDimmerEnabledProp === true &&
      this.showDynaTimeReferenceProp === true &&
      this.showDynaOverrideProp === true
    ) {
      //12 D, T, O
      featureParametersObj = {
        DynadimmerEnabled: DynadimmerEnabled[1],
        MidnightShift: Number(MidnightShift[1]),
        TimeReference: TimeReference[1],
        OverrideMode: OverrideMode[1],
        Scene1,
        Scene2,
        Scene3,
        Scene4,
        Scene5,
        Scene6,
        Scene7,
        Scene8,
        Scene9,
        Scene10,
      };
    } else if (
      this.showDynaDimmerEnabledProp === true &&
      this.showDynaTimeReferenceProp === true &&
      this.showDynaOverrideProp === false
    ) {
      //11 D, T
      featureParametersObj = {
        DynadimmerEnabled: DynadimmerEnabled[1],
        MidnightShift: Number(MidnightShift[1]),
        TimeReference: TimeReference[1],
        Scene1,
        Scene2,
        Scene3,
        Scene4,
        Scene5,
        Scene6,
        Scene7,
        Scene8,
        Scene9,
        Scene10,
      };
    } else if (
      this.showDynaDimmerEnabledProp === true &&
      this.showDynaTimeReferenceProp === false &&
      this.showDynaOverrideProp === true
    ) {
      //10 D, O
      featureParametersObj = {
        DynadimmerEnabled: DynadimmerEnabled[1],
        MidnightShift: Number(MidnightShift[1]),
        OverrideMode: OverrideMode[1],
        Scene1,
        Scene2,
        Scene3,
        Scene4,
        Scene5,
        Scene6,
        Scene7,
        Scene8,
        Scene9,
        Scene10,
      };
    } else if (
      this.showDynaDimmerEnabledProp === false &&
      this.showDynaTimeReferenceProp === true &&
      this.showDynaOverrideProp === true
    ) {
      featureParametersObj = {
        MidnightShift: Number(MidnightShift[1]),
        TimeReference: TimeReference[1],
        OverrideMode: OverrideMode[1],
        Scene1,
        Scene2,
        Scene3,
        Scene4,
        Scene5,
        Scene6,
        Scene7,
        Scene8,
        Scene9,
        Scene10,
      };
    } else if (
      this.showDynaDimmerEnabledProp === false &&
      this.showDynaTimeReferenceProp === true &&
      this.showDynaOverrideProp === false
    ) {
      //76206 T Only
      featureParametersObj = {
        MidnightShift: Number(MidnightShift[1]),
        TimeReference: TimeReference[1],
        Scene1,
        Scene2,
        Scene3,
        Scene4,
        Scene5,
        Scene6,
        Scene7,
        Scene8,
        Scene9,
        Scene10,
      };
    } else if (
      this.showDynaDimmerEnabledProp === true &&
      this.showDynaTimeReferenceProp === false &&
      this.showDynaOverrideProp === false
    ) {
      //09
      featureParametersObj = {
        DynadimmerEnabled: DynadimmerEnabled[1],
        MidnightShift: Number(MidnightShift[1]),
        Scene1,
        Scene2,
        Scene3,
        Scene4,
        Scene5,
        Scene6,
        Scene7,
        Scene8,
        Scene9,
        Scene10,
      };
    }

    if (featureParametersObj.Scene1 == null) {
      delete featureParametersObj.Scene1;
    }
    if (featureParametersObj.Scene2 == null) {
      delete featureParametersObj.Scene2;
    }
    if (featureParametersObj.Scene3 == null) {
      delete featureParametersObj.Scene3;
    }
    if (featureParametersObj.Scene4 == null) {
      delete featureParametersObj.Scene4;
    }
    if (featureParametersObj.Scene5 == null) {
      delete featureParametersObj.Scene5;
    }
    if (featureParametersObj.Scene6 == null) {
      delete featureParametersObj.Scene6;
    }
    if (featureParametersObj.Scene7 == null) {
      delete featureParametersObj.Scene7;
    }
    if (featureParametersObj.Scene8 == null) {
      delete featureParametersObj.Scene8;
    }
    if (featureParametersObj.Scene9 == null) {
      delete featureParametersObj.Scene9;
    }
    if (featureParametersObj.Scene10 == null) {
      delete featureParametersObj.Scene10;
    }

    FinaPayloadDyna.push(featureParametersObj);

    this.appState.setDynaSaveSetData(FinaPayloadDyna);
    this.sendDynaDimmerdata(FinaPayloadDyna[0]);
  }
  checkAddesRowValuesChanged(index) {
    this.rows.controls[index]["controls"].timeHHMM.valueChanges.subscribe(
      (value) => {
        // markForCheck ensures OnPush re-renders the error border immediately.
        // Error signalling is handled by onTimeInput / validateOrderOfHHMM to
        // avoid overwriting midnight-shift error state during programmatic setValue.
        this.cdRef.markForCheck();
        this.updateAddButtonStates();
      }
    );
    this.rows.controls[index]["controls"].outputLevel.valueChanges.subscribe(
      (value) => {
        this.submitted = false;
        this.tableValueSubmit = true;
        this.cdRef.markForCheck();
        this.updateAddButtonStates();
      }
    );
    this.rows.controls[index]["controls"].fadeTime.valueChanges.subscribe(
      (value) => {
        this.submitted = false;
        this.tableValueSubmit = true;
        this.cdRef.markForCheck();
        this.updateAddButtonStates();
      }
    );

    if (this.rows.length > this.maxRowCount - 1) {
      this.verifyDefaults();
    }
    this.validateOrderOfHHMM();
  }

  // Centralized method to update add button states based on form validity
  updateAddButtonStates() {
    setTimeout(() => {
      // Check if all rows have valid values
      const hasInvalidValues = !this.addForm.valid || !this.areAllRowsValid();

      if (this.rowLength === this.maxRowCount) {
        // At max row count: only disable the main add button, not above/below
        // (above/below are managed by onRightClick context menu)
        this.disableAddBtn = true;
      } else if (hasInvalidValues) {
        this.disableAddBtn = true;
        this.disableAddAboveBtn = true;
        this.disableAddBelowBtn = true;
      } else {
        this.disableAddBtn = false;
        this.disableAddAboveBtn = false;
        this.disableAddBelowBtn = false;
      }
    }, 50);
  }

  // Helper method to check if all rows have complete and valid values
  areAllRowsValid(): boolean {
    for (let i = 0; i < this.rows.length; i++) {
      const row = this.rows.controls[i];
      const timeHHMM = row.get('timeHHMM')?.value;
      const outputLevel = row.get('outputLevel')?.value;
      const fadeTime = row.get('fadeTime')?.value;

      // Check if LegacyAny field is empty, null, or undefined
      if (!timeHHMM || timeHHMM === '' ||
          outputLevel === null || outputLevel === undefined || outputLevel === '' ||
          fadeTime === null || fadeTime === undefined || fadeTime === '') {
        return false;
      }

      // Check if LegacyAny field has errors
      if (row.get('timeHHMM')?.errors ||
          row.get('outputLevel')?.errors ||
          row.get('fadeTime')?.errors) {
        return false;
      }
    }
    return true;
  }

  // Overall DynaDimmer validity: the schedule rows plus the midnight-shift field.
  private hasDynaError(): boolean {
    return !this.addForm.valid || !this.areAllRowsValid() || this.validMidNightPoint === false;
  }

  // Deferred emissions must recompute the state, otherwise a flag captured while
  // rows were mid-rebuild (e.g. Restore Default) is replayed and wins.
  private publishDynaValidity(): void {
    if (this.isDestroyed) {
      return;
    }
    this.isDynaDataError = this.hasDynaError();
    this.dynaDimmer.sendisDynaValid(this.isDynaDataError);
    this.cdRef.markForCheck();
  }

  createItemFormGroup(): FormGroup {
    return this.fb.group({
      timeHHMM: [
        null,
        [
          Validators.required,
          Validators.pattern("^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$"),
        ],
      ],
      outputLevel: [
        null,
        [
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.min(0),
          Validators.max(100),
        ],
      ],
      fadeTime: [
        null,
        [
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.min(0),
          Validators.max(255),
        ],
      ],
    });
  }

  clearTableValueFields() {
    this.clearValues();
    setTimeout(() => {
      this.isclearTableValueFieldscalled = true;
      this.addDefaultRowSet();
      this.disableAddBtn = false;
      this.disableAddAboveBtn = false;
      this.disableAddBelowBtn = false;
    }, 100);
    this.defaultColor = false;
    // this.featureDefaults.setDynaDefaultColor(this.defaultColor);
    // After clearing, the form is invalid (empty fields), so buttons should be disabled
    this.verifyDefaults();
    this.dynaDimmer.emitDynaUserInteracted();
  }

  clearValues() {
    this.unsubscribe.next(undefined);
    this.isNumericCreatedRows = false;
    this.rows.clear();
    this.onAddRow();
    //this.dataToShow = [];
    //this.dataToShow.push({ hour: 0, power: 100 })
    this.rows.controls[0]["controls"].timeHHMM.setValue("");
    this.rows.controls[0]["controls"].outputLevel.setValue("");
    this.rows.controls[0]["controls"].fadeTime.setValue("");
    this.defaultColor = true;
    //this.featureDefaults.setDynaDefaultColor(this.defaultColor);
    //this.graphState.sendGraphIsEditedData([{ hour: 0, power: 100 }]);
    //this.graphState.sendDynaGraphData(this.graphRepresentationType, this.dataToShow);
    this.tableValueSubmit = false;
    this.isTableValuesChanged = false;
    this.isDynaDataError = true;
  }

  enableDynaGraph(value) {
    this.dynaEnableMode = value;
    if (this.dynaEnableMode) {
      this.dynaEnableMode = true;
      this.disable = false;
      this.dynaDimmer.sendDynaDimmerEnabledMode(true);
    } else {
      this.dynaEnableMode = false;
      this.disable = true;
      this.dynaDimmer.sendDynaDimmerEnabledMode(false);
    }
    this.applyDynaRowsDisabledState();
    this.verifyDefaults();
    this.dynaDimmer.emitDynaUserInteracted();
    this.validateOrderOfHHMM();
  }

  // Enable/disable form controls for a specific row
  private setRowControlsState(index: number, enabled: boolean): void {
    const row = this.rows.controls[index];
    if (!row) {
      return;
    }

    const action = enabled ? 'enable' : 'disable';
    row.get('timeHHMM')?.[action]({ emitEvent: false });
    row.get('outputLevel')?.[action]({ emitEvent: false });
    row.get('fadeTime')?.[action]({ emitEvent: false });
  }

  // Enable all form controls in the rows array
  enableFormControls() {
    this.rows.controls.forEach((_, index) => {
      this.setRowControlsState(index, true);
    });
  }

  // Disable all form controls in the rows array
  disableFormControls() {
    this.rows.controls.forEach((_, index) => {
      this.setRowControlsState(index, false);
    });
  }
    // Syncs the scene-row controls with the current `disable` flag.
  private applyDynaRowsDisabledState(): void {
    if (this.disable) {
      this.disableFormControls();
    } else {
      this.enableFormControls();
    }
  }
  timeBaseclicked() {
    this.dynaDimmer.sendDynaTimeReferenceMode(this.dynaTimeReferenceMode);
    this.verifyDefaults();
    this.validateOrderOfHHMM();
  }
  toggleTimeReference(value) {
    this.testInput.nativeElement.setSelectionRange(0, 0);

    this.testInput.nativeElement.focus();

    setTimeout(() => {
      this.testInput.nativeElement.dispatchEvent(
        new KeyboardEvent("keydown", { key: "Tab" })
      );
    }, 0);

    if (Boolean(value) === true) {
      this.dynaTimeReferenceMode = true;
      this.dynaMidNightShiftMode = false;
      // Reset midnight shift to 0 only if it's in error state, otherwise retain valid value
      if (!this.validMidNightPoint) {
        this.midnightShiftEditedValue = 0;
        this.validMidNightPoint = true;
      }
      this.dynaDimmer.sendDynaTimeReferenceMode(true);
      this.dynaDimmer.sendDynaMidPointShiftMode(false);
    } else if (Boolean(value) === false) {
      this.dynaTimeReferenceMode = false;
      this.dynaMidNightShiftMode = true;

      this.dynaDimmer.sendDynaTimeReferenceMode(false);
      this.dynaDimmer.sendDynaMidPointShiftMode(true);
    }

    this.verifyDefaults();
    this.dynaDimmer.emitDynaUserInteracted();
    this.validateOrderOfHHMM();
  }

  toggleOverrideMode(value:boolean) {
    if (value === true) {
      this.dynaOverrideMode = true;
    } else {
      this.dynaOverrideMode = false;
    }
    this.dynaDimmer.sendDynaOveerideMode(this.dynaOverrideMode);

    this.verifyDefaults();
    this.dynaDimmer.emitDynaUserInteracted();
    this.validateOrderOfHHMM();
  }
  verifyDefaults() {
    if (this.isDestroyed) {
      return;
    }

    if (!this.rows || !this.rows.controls) {
      return;
    }
    let defaultCheck = true;
    const sceneChnaged = false;
    const dynaDimmerReadSchema = this.appState.getDynaDimmerSchema();
    if (!dynaDimmerReadSchema || !dynaDimmerReadSchema[0] || !dynaDimmerReadSchema[0]["properties"]) {
      return;
    }
    const schemaProperties = dynaDimmerReadSchema[0]["properties"];
    const scenes = schemaProperties["NumberOfScenes"]?.["default"];
    if (typeof scenes !== "number" || scenes < 1) {
      return;
    }
    if (this.rows.length === 1) {
      const scene1Properties = schemaProperties["Scene1"]?.["properties"];
      if (!scene1Properties) {
        return;
      }
      const time = this.rows.controls[0]["controls"].timeHHMM.value;
      const outpt = this.rows.controls[0]["controls"].outputLevel.value;
      const fadetime = this.rows.controls[0]["controls"].fadeTime.value;
      let hourDefault = scene1Properties["Hour"]?.["default"];
      let minuteDefault = scene1Properties["Minute"]?.["default"];
      const fadeTimeDefault = scene1Properties["FadeTime"]?.["default"];
      const outputLevelDefault = scene1Properties["DimLevel"]?.["default"];
      if (
        hourDefault === undefined ||
        minuteDefault === undefined ||
        fadeTimeDefault === undefined ||
        outputLevelDefault === undefined
      ) {
        return;
      }
      hourDefault = hourDefault <= 9 ? "0" + hourDefault : hourDefault;
      minuteDefault = minuteDefault <= 9 ? "0" + minuteDefault : minuteDefault;
      if (hourDefault <= 9) {
        hourDefault = parseInt(hourDefault);
        if (time !== `${hourDefault}` + ":" + `${minuteDefault}`) {
          defaultCheck = false;
        }
      } else if (
        (time != null) &&
        time !== `${hourDefault}` + ":" + `${minuteDefault}`
      ) {
        defaultCheck = false;
      }
      if (
        (outpt != null) &&
        String(outpt) !== outputLevelDefault.toString()
      ) {
        defaultCheck = false;
      }
      if (
        (fadetime != null) &&
        String(fadetime) !== fadeTimeDefault.toString()
      ) {
        defaultCheck = false;
      }
    } else if (this.rows.length > scenes || this.rows.length < scenes) {
      defaultCheck = false;
    } else {
      const defaultPool: { timeHHMM: string, outputLevel: string, fadeTime: string }[] = [];
      for (let k = 1; k <= scenes; k++) {
        const sceneProperties = schemaProperties["Scene" + k]?.["properties"];
        if (!sceneProperties) {
          defaultCheck = false;
          break;
        }
        const h = sceneProperties["Hour"]?.["default"];
        const m = sceneProperties["Minute"]?.["default"];
        const dimLevelDefault = sceneProperties["DimLevel"]?.["default"];
        const fadeTimeDefault = sceneProperties["FadeTime"]?.["default"];
        if (
          h === undefined ||
          m === undefined ||
          dimLevelDefault === undefined ||
          fadeTimeDefault === undefined
        ) {
          defaultCheck = false;
          break;
        }
        const hStr = h <= 9 ? "0" + h : "" + h;
        const mStr = m <= 9 ? "0" + m : "" + m;
        defaultPool.push({
          timeHHMM: hStr + ":" + mStr,
          outputLevel: dimLevelDefault.toString(),
          fadeTime: fadeTimeDefault.toString(),
        });
      }

      for (let i = 0; i < this.rows.length; i++) {
        if (!this.rows.controls[i] || !this.rows.controls[i]["controls"]){
          continue;
        }
        const time = this.rows.controls[i]["controls"].timeHHMM.value;
        const outpt = this.rows.controls[i]["controls"].outputLevel.value;
        const fadetime = this.rows.controls[i]["controls"].fadeTime.value;
        if (time == null && outpt == null && fadetime == null){
          continue;
        }

        const matchIndex = defaultPool.findIndex(d =>
          d.timeHHMM === time &&
          d.outputLevel === String(outpt) &&
          d.fadeTime === String(fadetime)
        );
        if (matchIndex === -1) {
          defaultCheck = false;
          break;
        }
        defaultPool.splice(matchIndex, 1);
      }
    }

    if (
      this.showDynaDimmerEnabledProp != undefined &&
      this.showDynaDimmerEnabledProp
    ) {
      if (
        this.dynaDefaultEnabled != undefined &&
        this.dynaDefaultEnabled !== this.dynaEnableMode
      ) {
        defaultCheck = false;
      }
    }
    if (
      this.showDynaTimeReferenceProp != undefined &&
      this.showDynaTimeReferenceProp
    ) {
      if (
        this.dynaDefaultTimeBased != undefined &&
        this.dynaDefaultTimeBased !== this.dynaTimeReferenceMode
      ) {
        defaultCheck = false;
      }
    }
    if (this.showDynaOverrideProp != undefined && this.showDynaOverrideProp) {
      if (
        this.dynaDefaultOverride != undefined &&
        this.dynaDefaultOverride !== this.dynaOverrideMode
      ) {
        defaultCheck = false;
      }
    }
    if (
      this.midnightShiftEditedValue != undefined &&
      (Number(this.midnightShiftEditedValue) !== 0 ||
        this.midnightShiftEditedValue === null)
    )
      defaultCheck = false;

    if (
      Number(this.midnightShiftEditedValue) !== 0 ||
      this.midnightShiftEditedValue === null
    )
      defaultCheck = false;

    // An emptied/out-of-range midnight shift is never the default state.
    if (this.validMidNightPoint === false) {
      defaultCheck = false;
    }
    // if (sceneChnaged === true) {
    //   defaultCheck = false;
    // }
    // if(this.dynaDefaultEnabled===this.dynaEnableMode && this.dynaDefaultTimeBased === this.dynaTimeReferenceMode && this.dynaDefaultOverride=== this.dynaOverrideMode && this.midnightShiftEditedValue===0 && sceneChnaged===false)
    // this.featureDefaults.setDynaDefaultColor(true);
    // else
    // this.featureDefaults.setDynaDefaultColor(false);
    // setTimeout(() => {
    this.featureDefaults.setDynaDefaultColor(defaultCheck);
    this.dynaDimmer.setDynaDimmerEdited(true);
    // }, 500);
  }

  AddRow() {
    //this.featureDefaults.setDynaDefaultColor(false);
    this.onAddRow();
    const rowCnt = this.rows.length;
    if (rowCnt > 1 && rowCnt < this.maxRowCount + 1) {
      setTimeout(() => {
        this.validateOrderOfHHMM();
        this.addIncrementDefaultValues(rowCnt);
      }, 10);
    }
    // Button states are handled by onAddRow -> updateAddButtonStates

    // Trigger include in configuration after row is fully set up
    setTimeout(() => {
      this.verifyDefaults();
      this.dynaDimmer.emitDynaUserInteracted();
    }, 20);

    this.testInput.nativeElement.setSelectionRange(0, 0);

    this.testInput.nativeElement.focus();

    setTimeout(() => {
      this.testInput.nativeElement.dispatchEvent(
        new KeyboardEvent("keydown", { key: "Tab" })
      );
    }, 0);
  }
  addIncrementDefaultValues(rowCnt: number) {
    const rowCntRead = rowCnt - 2;

    // Walk backwards to find the last row with a valid (non-empty) time
    let validReadIndex = rowCntRead;
    while (validReadIndex >= 0) {
      const t = this.rows.controls[validReadIndex]["controls"].timeHHMM.value;
      if (t && t !== '' && t.includes(':')) {
        break;
      }
      validReadIndex--;
    }
    if (validReadIndex < 0) {
      validReadIndex = 0;
    }

    let time = this.rows.controls[validReadIndex]["controls"].timeHHMM.value || '12:00';
    let outpt = this.rows.controls[validReadIndex]["controls"].outputLevel.value;
    let fadeTime = this.rows.controls[validReadIndex]["controls"].fadeTime.value;

    const dynaDimmerReadSchema = this.appState.getDynaDimmerSchema();
    this.defaultColor = false;
    this.featureDefaults.setDynaDefaultColor(this.defaultColor);
    if (
      this.dynaTimeReferenceMode === false ||
      this.dynaTimeReferenceMode === true
    ) {
      const sceneval = rowCntRead + 2;

      if (
        (sceneval === 2 && this.isclearTableValueFieldscalled) ||
        sceneval === 3 ||
        sceneval === 4 ||
        sceneval === 5 ||
        sceneval === 6 ||
        sceneval === 7 ||
        sceneval === 8 ||
        sceneval === 9 ||
        sceneval === 10 ||
        rowCnt === 2
      ) {
        const fadeTimeDefault: number = 0;
        let outputLevelDefault: number =
          Number(this.rows.controls[validReadIndex]["controls"].outputLevel.value) +
          10;
        if (outputLevelDefault > 100)
          outputLevelDefault = outputLevelDefault - 100;
        const timeInc: string[] =
          (this.rows.controls[validReadIndex]["controls"].timeHHMM.value || '12:00').split(":");
        timeInc[0] = timeInc[0].replace(/^0+/, "");

        timeInc[1] = Number(timeInc[1]).toString();
        if (Number(timeInc[0]) <= 9) {
          time = Number(timeInc[0]) + 1;
          if (time < 10) {
            timeInc[0] = "0" + time.toString();
          } else {
            timeInc[0] = time.toString();
          }
        } else if (Number(timeInc[0]) === 23) {
          time = Number(0);
          timeInc[0] = "0" + time.toString();
        } else if (Number(timeInc[0]) > 9 && Number(timeInc[0]) <= 23) {
          time = Number(timeInc[0]) + 1;
          timeInc[0] = time.toString();
        }
        if (Number(timeInc[1]) <= 9) {
          const sec = Number(timeInc[1]);
          if (sec !== 10) {
            timeInc[1] = "0" + sec.toString();
          } else {
            timeInc[1] = sec.toString();
          }
        } else {
          timeInc[1] = Number(timeInc[1]).toString();
        }
        const hourDefault: LegacyAny = timeInc[0].concat(":" + timeInc[1]);
        time = hourDefault;
        outpt = outputLevelDefault;
        fadeTime = fadeTimeDefault;
      } else if (sceneval === 1 && this.isclearTableValueFieldscalled) {
        const fadeTimeDefault: number = 0;
        const outputLevelDefault: number = 100;
        this.rows.controls[0]["controls"].timeHHMM.setValue("12:00");
        this.rows.controls[0]["controls"].outputLevel.setValue(
          outputLevelDefault
        );
        this.rows.controls[0]["controls"].fadeTime.setValue(fadeTimeDefault);
        this.addForm.addControl("rows", this.rows);
        this.rowLength = this.rows.length;
        this.appState.setDynaScenes({
          timeHHMM: "12:00",
          outputLevel: outputLevelDefault,
          fadeTime: fadeTimeDefault,
        });
      } else {
        let hourDefault: LegacyAny =
          dynaDimmerReadSchema[0]["properties"]["Scene" + `${sceneval}`][
            "properties"
          ]["Hour"]["default"];
        let minuteDefault =
          dynaDimmerReadSchema[0]["properties"]["Scene" + `${sceneval}`][
            "properties"
          ]["Minute"]["default"];
        const outputLevelDefault: number =
          dynaDimmerReadSchema[0]["properties"]["Scene" + `${sceneval}`][
            "properties"
          ]["DimLevel"]["default"];
        const fadeTimeDefault: number =
          dynaDimmerReadSchema[0]["properties"]["Scene" + `${sceneval}`][
            "properties"
          ]["FadeTime"]["default"];

        hourDefault =
          Number(hourDefault) <= 9
            ? "0" + Number(hourDefault).toString()
            : Number(hourDefault).toString();
        hourDefault = hourDefault.replace(/^0+/, "");
        if (hourDefault !== Number(10).toString()) {
          hourDefault = "0" + hourDefault;
        }
        minuteDefault =
          Number(minuteDefault) <= 9
            ? "0" + Number(minuteDefault).toString()
            : Number(minuteDefault).toString();
        minuteDefault = minuteDefault.replace(/^0+/, "");
        if (minuteDefault !== Number(10).toString()) {
          minuteDefault = "0" + minuteDefault;
        }
        time = `${hourDefault}` + ":" + `${minuteDefault}`;
        outpt = outputLevelDefault;
        fadeTime = fadeTimeDefault;
      }
    }
    const rowCntWrite = rowCnt - 1;
    this.rows.controls[rowCntWrite]["controls"].timeHHMM.setValue(time);
    this.rows.controls[rowCntWrite]["controls"].outputLevel.setValue(outpt);
    this.rows.controls[rowCntWrite]["controls"].fadeTime.setValue(fadeTime);
  }
  moMouseAddEnter() {
    const hasErrors = !this.areAllRowsValid() || !this.addForm.valid;
    if (this.rows.length >= this.maxRowCount || hasErrors) {
      this.disableAddBtn = true;
      this.disableAddAboveBtn = true;
      this.disableAddBelowBtn = true;
    } else {
      this.disableAddBtn = false;
      this.disableAddAboveBtn = false;
      this.disableAddBelowBtn = false;
    }
  }
  RemoveRow(index) {
    this.rows.removeAt(index);
    this.rowLength = this.rows.length;

    // Synchronous button state update based on row count vs maxRowCount
    if (this.rowLength < this.maxRowCount) {
      this.disableAddBtn = false;
      this.disableAddAboveBtn = false;
      this.disableAddBelowBtn = false;
    } else {
      this.disableAddBtn = true;
      this.disableAddAboveBtn = true;
      this.disableAddBelowBtn = true;
    }

    const dynaDimmerReadSchema = this.appState.getDynaDimmerSchema();
    const scenes =
      dynaDimmerReadSchema[0]["properties"]["NumberOfScenes"]["default"];

    // Always re-validate order and regenerate graph data after a row is removed,
    // regardless of whether the remaining row count matches the default scene count.
    this.validateOrderOfHHMM();
    this.verifyDefaults();
    if (this.rowLength !== scenes) {
      this.defaultColor = false;
      this.featureDefaults.setDynaDefaultColor(this.defaultColor);
    }
    this.cdRef.markForCheck();
  }

  onUserRemoveRow(index) {
    this.RemoveRow(index);
    this.verifyDefaults();
    this.dynaDimmer.emitDynaUserInteracted();
  }

  onRightClick($event, index) {
    if (this.disable) {
    this.menuState = false;
    return;
    }
    this.selectedRow = index;
    event.stopPropagation();
    this.menuState = true;
    this.positionMenu(event);

    if (
      this.rowLength === this.maxRowCount ||
      this.rowLength > this.maxRowCount
    ) {
      this.disableAddBtn = true;
      this.disableAddAboveBtn = true;
      this.disableAddBelowBtn = true;
    }
  }

  addRowPosition(rowType) {
    if (this.rowLength < this.maxRowCount) {
      if (rowType === "Above")
        this.rows.insert(this.selectedRow, this.createItemFormGroup());

      if (rowType === "Below")
        this.rows.insert(this.selectedRow + 1, this.createItemFormGroup());

      this.rowLength = this.rows.length;

      // Apply disabled state to newly inserted row if form is disabled
      if (this.disable) {
        const insertedIndex = rowType === "Above" ? this.selectedRow : this.selectedRow + 1;
        this.setRowControlsState(insertedIndex, false);
      }

      // Update button states immediately (tick 0) - check row count and form validity
      setTimeout(() => {
        const hasInvalidValues = !this.addForm.valid || !this.areAllRowsValid();
        if (this.rowLength >= this.maxRowCount || hasInvalidValues) {
          this.disableAddBtn = true;
          this.disableAddAboveBtn = true;
          this.disableAddBelowBtn = true;
        } else {
          this.disableAddBtn = false;
          this.disableAddAboveBtn = false;
          this.disableAddBelowBtn = false;
        }
        this.verifyDefaults();
      }, 0);

      this.checkAddesRowValuesChanged(this.selectedRow);
    }
  }

  getPosition(e) {
    let posx = 0;
    let posy = 0;
    if (e.pageX || e.pageY) {
      posx = e.pageX;
      posy = e.pageY;
    } else if (e.clientX || e.clientY) {
      posx =
        e.clientX +
        document.body.scrollLeft +
        document.documentElement.scrollLeft;
      posy =
        e.clientY +
        document.body.scrollTop +
        document.documentElement.scrollTop;
    }
    return { x: posx, y: posy };
  }

  positionMenu(e) {
    this.menuPosition = this.getPosition(e);
    this.menuPositionX = this.menuPosition.x;
    this.menuPositionY = this.menuPosition.y;
    this.cdRef.detectChanges();
    this.menuWidth = this.contextMenu.nativeElement.offsetWidth;
    this.menuHeight = this.contextMenu.nativeElement.offsetHeight;
    this.windowWidth = window.innerWidth;
    this.windowHeight = window.innerHeight;
    if (Math.abs(this.windowWidth - this.menuPositionX) < this.menuWidth) {
      this.menuPositionX = this.windowWidth - this.menuWidth - 250 + "px";
    } else {
      //this.menuPositionX = this.menuPositionX - 250+ "px";
      this.menuPositionX = 190 + "px";
    }
    if (Math.abs(this.windowHeight - this.menuPositionY) < this.menuHeight) {
      this.menuPositionY = this.windowHeight - this.menuHeight - 50 + "px";
    } else {
      this.menuPositionY = this.menuPositionY - 50 + "px";
    }
  }
  @HostListener("document:click", ["$event"])
  public documentClick(event: Event): void {
    this.menuState = false;
  }
  @HostListener("document:contextmenu", ["$event"])
  public documentRClick(event: Event): void {
    this.menuState = false;
  }

  ngOnDestroy() {
    this.isDestroyed = true;
    clearTimeout(this.midnightShiftEmitTimer);
    this.unsubscribeGraphType.next(undefined);
    this.unsubscribeNumeric.next(undefined);
    // this.subscription.unsubscribe();
    if (this.dynaMidPointShiftValueSub) {
      this.dynaMidPointShiftValueSub.unsubscribe();
    }
    if (this.getDynaMidPointShiftValueSub) {
      this.getDynaMidPointShiftValueSub.unsubscribe();
    }
    if (this.getDynaMidPointSHiftDefaultPropertiesSub) {
      this.getDynaMidPointSHiftDefaultPropertiesSub.unsubscribe();
    }
    if (this.graphDynaData) {
      this.graphDynaData.unsubscribe();
    }
    if (this.dynaDefaultValue) {
      this.dynaDefaultValue.unsubscribe();
    }
    if (this.getDynaOverrideModeSub) {
      this.getDynaOverrideModeSub.unsubscribe();
    }

    if (this.getDynaShowOverrideEnabledSub) {
      this.getDynaShowOverrideEnabledSub.unsubscribe();
    }
  }

  calculateMidnightShiftTime() {
    const modalRef = this.modalService.open(MidnightShiftCalculationComponent, {
      backdrop: "static",
      keyboard: false,
      windowClass: "select-device-modal",
      centered: true,
    });
  }

  onKey1($event: KeyboardEvent) {
  }
}
